import { render } from "./HelloWorld.vue?vue&type=template&id=24f9b08a&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=24f9b08a&scoped=true&lang=css"

import exportComponent from "/Users/mustafatofur/Desktop/Work/ProjectCountMap/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24f9b08a"]])

export default __exports__